import { useState } from "react";
import { ADVISORY_BOARD, STEERING_COMMITTEE, RESEARCH_FACILITIES } from "../data/constants";
import { C } from "../theme/colors";
import Divider from "../components/Divider";
import PageHero from "../components/PageHero";

export default function AboutPage() {
  const [activeTab, setActiveTab] = useState("advisory");
  const tabs = [
    { id: "advisory", label: "Advisory Board" },
    { id: "steering", label: "Steering Committee" },
    { id: "institution", label: "About BITS Pilani" },
    { id: "facilities", label: "Research Facilities" },
  ];

  return (
    <div className="page-fade">
      {/* Scoped responsive rules for this page only */}
      <style>{`
        @media (max-width: 900px) {
          .about-tab-panel { padding-left: 20px !important; padding-right: 20px !important; }
          .about-tabs-wrap { padding-left: 20px !important; padding-right: 20px !important; }
          .grid-2 { grid-template-columns: 1fr !important; gap: 28px !important; }
          .grid-4 { grid-template-columns: repeat(2, 1fr) !important; }
          .stats-grid { grid-template-columns: repeat(3, 1fr) !important; }
          .institution-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
          .institution-grid > div:first-child { order: 2; }
          .institution-grid > div:last-child { order: 1; }
          .advisory-row { grid-template-columns: 60px 1fr 140px !important; }
          .advisory-header { grid-template-columns: 60px 1fr 140px !important; }
        }
        @media (max-width: 640px) {
          .about-tab-panel { padding: 40px 16px 56px !important; }
          .about-tabs-wrap { padding-left: 16px !important; padding-right: 16px !important; }
          .grid-4 { grid-template-columns: 1fr !important; }
          .stats-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .advisory-table-wrap { overflow-x: auto !important; -webkit-overflow-scrolling: touch; }
          .advisory-row, .advisory-header {
            grid-template-columns: 44px 1fr !important;
            min-width: 480px;
          }
          .advisory-position-col { display: none !important; }
          .facilities-row { padding: 14px 16px !important; }
          .hero-image { height: 180px !important; }
        }
        @media (max-width: 480px) {
          .about-tabs-wrap button { padding: 14px 16px !important; font-size: 12.5px !important; }
        }
      `}</style>

      <PageHero title="About CRENS" tag="Centre Overview" subtitle="A strategic Centre of Excellence at BITS Pilani, advancing India's national security through research, innovation, and indigenous technology development."/>
      <div style={{background:C.white,borderBottom:`1px solid ${C.border}`,position:"sticky",top:66,zIndex:100}}>
        <div className="about-tabs-wrap" style={{maxWidth:1260,margin:"0 auto",padding:"0 40px",display:"flex",gap:0,overflowX:"auto"}}>
          {tabs.map(tab => (
            <button key={tab.id} onClick={() => setActiveTab(tab.id)}
              style={{background:"none",border:"none",cursor:"pointer",padding:"18px 24px",fontFamily:"Arial,Helvetica,sans-serif",fontSize:13.5,fontWeight:activeTab===tab.id?700:500,color:activeTab===tab.id?C.navy:C.textMuted,borderBottom:activeTab===tab.id?`2.5px solid ${C.navy}`:"2.5px solid transparent",transition:"all .2s",whiteSpace:"nowrap",letterSpacing:0.2,flexShrink:0}}>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {activeTab === "advisory" && (
        <div className="page-fade about-tab-panel" style={{padding:"56px 40px 80px",background:C.bgAlt}}>
          <div style={{maxWidth:1100,margin:"0 auto"}}>
            <h2 style={{fontFamily:"var(--font-heading)",fontWeight:700,fontSize:"1.75rem",color:C.navyDark,marginBottom:32}}>Advisory Board</h2>
            <div className="advisory-table-wrap" style={{borderRadius:10,overflow:"hidden",border:`1px solid ${C.border}`,marginBottom:40,boxShadow:"0 2px 12px rgba(15,37,87,0.06)"}}>
              <div className="advisory-header" style={{display:"grid",gridTemplateColumns:"80px 1fr 180px",background:"#0F2557",padding:"16px 24px",gap:0}}>
                <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:13,fontWeight:600,color:"rgba(255,255,255,0.85)"}}>S.N</span>
                <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:13,fontWeight:600,color:"rgba(255,255,255,0.85)"}}>Name & Designation</span>
                <span className="advisory-position-col" style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:13,fontWeight:600,color:"rgba(255,255,255,0.85)"}}>Position</span>
              </div>
              {ADVISORY_BOARD.map((m, i) => (
                <div key={i} className="advisory-row" style={{display:"grid",gridTemplateColumns:"80px 1fr 180px",alignItems:"center",gap:0,padding:"18px 24px",background:i%2===0?"#FFFFFF":"#F0F4F8",borderBottom:i<ADVISORY_BOARD.length-1?`1px solid ${C.borderLight}`:"none",transition:"background .15s"}}>
                  <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:14,fontWeight:700,color:C.navyDark}}>{m.sn}</span>
                  <div>
                    <div style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:14,fontWeight:700,color:C.navy,marginBottom:4,lineHeight:1.3}}>{m.name}</div>
                    <div style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:12.5,color:C.textMuted,lineHeight:1.4}}>{m.designation}</div>
                  </div>
                  <span className="advisory-position-col" style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:13.5,color:C.textMid,fontWeight:400}}>{m.position}</span>
                </div>
              ))}
            </div>
            <div className="grid-2" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:24}}>
              <div style={{background:C.white,borderRadius:10,padding:"24px 28px",border:`1px solid ${C.border}`}}>
                <div style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:11,fontWeight:700,letterSpacing:2,textTransform:"uppercase",color:C.gold,marginBottom:18}}>Permanent Invitees</div>
                {["Financial Adviser (Acquisition), MoD","DCIDS (Policy, Plans & Force Development)","JS & Acquisition Manager (Navy), MoD"].map((item,i) => (
                  <div key={i} style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
                    <div style={{width:5,height:5,borderRadius:"50%",background:C.gold,flexShrink:0}}/>
                    <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:13.5,color:C.textMid,lineHeight:1.5}}>{item}</span>
                  </div>
                ))}
              </div>
              <div style={{background:C.white,borderRadius:10,padding:"24px 28px",border:`1px solid ${C.border}`}}>
                <div style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:11,fontWeight:700,letterSpacing:2,textTransform:"uppercase",color:C.gold,marginBottom:18}}>Special Invitees</div>
                {["Director General, NIC","Director, Intelligence Bureau","Chief of Integrated Defence Staff"].map((item,i) => (
                  <div key={i} style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
                    <div style={{width:5,height:5,borderRadius:"50%",background:C.gold,flexShrink:0}}/>
                    <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:13.5,color:C.textMid,lineHeight:1.5}}>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === "steering" && (
        <div className="page-fade about-tab-panel" style={{padding:"56px 40px 80px",background:C.bgAlt}}>
          <div style={{maxWidth:1200,margin:"0 auto"}}>
            <h2 style={{fontFamily:"var(--font-heading)",fontWeight:700,fontSize:"1.75rem",color:C.navyDark,marginBottom:36}}>Steering Committee</h2>
            <div className="grid-4" style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:16}}>
              {STEERING_COMMITTEE.map((m, i) => (
                <div key={i} style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:10,padding:"18px 20px",transition:"box-shadow .2s, border-color .2s",cursor:"default"}}
                  onMouseEnter={e=>{e.currentTarget.style.borderColor=C.accentDeep;e.currentTarget.style.boxShadow="0 4px 16px rgba(15,37,87,0.09)";}}
                  onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;e.currentTarget.style.boxShadow="none";}}>
                  <div style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:14,fontWeight:700,color:C.navyDark,marginBottom:6,lineHeight:1.3}}>{m.name}</div>
                  <div style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:12.5,color:C.textMuted,lineHeight:1.45}}>{m.role}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {activeTab === "institution" && (
        <div className="page-fade about-tab-panel" style={{padding:"72px 40px",background:C.white}}>
          <div style={{maxWidth:1100,margin:"0 auto"}}>
            <div className="grid-2 institution-grid" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:72,alignItems:"start"}}>
              <div>
                <span className="section-tag">The Institution</span>
                <h2 style={{fontFamily:"var(--font-heading)",fontWeight:700,fontSize:"clamp(1.5rem,2.5vw,2.2rem)",color:C.navyDark,marginTop:10}}>Birla Institute of Technology & Science (BITS), Pilani</h2>
                <Divider/>
                <p className="body" style={{marginBottom:18}}>BITS Pilani is one of India's premier technical universities, designated as an Institute of Eminence by the Government of India. With five campuses — Pilani, Goa, Hyderabad, Dubai, and Mumbai — and a global alumni network spanning 150+ countries, BITS provides CRENS with unparalleled intellectual and infrastructural resources.</p>
                <p className="body" style={{marginBottom:28}}>The institute secures extramural research funds from industries and various government agencies across fifteen academic departments. Backed by the Aditya Birla Group and established in 1964, BITS has consistently ranked among India's top technical institutions.</p>
                <div style={{padding:"22px 26px",background:C.goldBg,borderLeft:`3px solid ${C.gold}`,borderRadius:"0 10px 10px 0"}}>
                  <p style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:15,color:C.text,lineHeight:1.85,fontStyle:"italic",marginBottom:10}}>"Established on 6th August 2024 as a strategic initiative to enhance the nation's security capabilities and make India self-reliant in the national security domain."</p>
                  <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:12.5,fontWeight:700,color:C.gold}}>— CRENS, BITS Pilani</span>
                </div>
              </div>
              <div>
                <img className="hero-image" src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/BITS_Pilani_Hyderabad_Campus_Main_Building.jpg/1280px-BITS_Pilani_Hyderabad_Campus_Main_Building.jpg" alt="BITS Pilani Hyderabad Campus" style={{width:"100%",borderRadius:14,objectFit:"cover",height:220,marginBottom:24}} onError={e=>e.target.style.display="none"}/>
                <div className="stats-grid" style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:10}}>
                  {[["5","Campuses"],["15+","Departments"],["₹375 Cr","Funding"],["350+","Patents"],["Institute","of Eminence"]].map(([n,l],i) => (
                    <div key={i} style={{background:C.bgAlt,borderRadius:10,padding:"14px 10px",textAlign:"center",border:`1px solid ${C.border}`}}>
                      <div style={{fontFamily:"Arial,Helvetica,sans-serif",fontWeight:700,fontSize:15,color:C.navy,lineHeight:1,marginBottom:4}}>{n}</div>
                      <div style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:10,color:C.textMuted,lineHeight:1.3}}>{l}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === "facilities" && (
        <div className="page-fade about-tab-panel" style={{padding:"72px 40px",background:C.white}}>
          <div style={{maxWidth:1100,margin:"0 auto"}}>
            <div style={{marginBottom:48}}>
              <span className="section-tag">Infrastructure</span>
              <h2 style={{fontFamily:"var(--font-heading)",fontWeight:700,fontSize:"clamp(1.5rem,2.5vw,2.2rem)",color:C.navyDark,marginTop:10}}>State-of-Art Research Facilities at BITS, Pilani</h2>
              <Divider/>
              <p className="body" style={{maxWidth:620}}>World-class laboratories and research infrastructure enabling cutting-edge work across all national security domains.</p>
            </div>
            <div className="grid-2" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
              {RESEARCH_FACILITIES.map((f, i) => (
                <div key={i} className="facilities-row" style={{display:"flex",alignItems:"center",gap:14,padding:"16px 20px",background:C.bgAlt,borderRadius:10,border:`1px solid ${C.borderLight}`,transition:"all .2s"}}
                  onMouseEnter={e=>{e.currentTarget.style.borderColor=C.accentDeep;e.currentTarget.style.background=C.accent;}}
                  onMouseLeave={e=>{e.currentTarget.style.borderColor=C.borderLight;e.currentTarget.style.background=C.bgAlt;}}>
                  <div style={{width:30,height:30,borderRadius:6,background:C.navy,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:11,fontWeight:700,color:C.goldLight}}>{String(i+1).padStart(2,"0")}</span>
                  </div>
                  <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:13.5,color:C.textMid,lineHeight:1.4}}>{f}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}